import {
  COA_NON_TAX_GST_MAP_REQUEST,
  COA_NON_TAX_GST_MAP_SUCCESS,
  COA_NON_TAX_GST_MAP_FAIL,

  CREATE_COA_NON_TAX_GST_MAP_REQUEST,
  CREATE_COA_NON_TAX_GST_MAP_SUCCESS,
  CREATE_COA_NON_TAX_GST_MAP_FAIL,

  UPDATE_COA_NON_TAX_GST_MAP_REQUEST,
  UPDATE_COA_NON_TAX_GST_MAP_SUCCESS,
  UPDATE_COA_NON_TAX_GST_MAP_FAIL,

  DELETE_COA_NON_TAX_GST_MAP_REQUEST,
  DELETE_COA_NON_TAX_GST_MAP_SUCCESS,
  DELETE_COA_NON_TAX_GST_MAP_FAIL,

  CLEAR_ERROR,
} from "../../../constants/CoaManagement/CoaMapping/CoaNonTaxGstMapConstant";


// create, update, delete and get all
export const getCoaNonTaxGstMapsReducer = (state = { coaNonTaxGstMaps: [] }, action) => {
  switch (action.type) {
    case COA_NON_TAX_GST_MAP_REQUEST:
    case CREATE_COA_NON_TAX_GST_MAP_REQUEST:
    case UPDATE_COA_NON_TAX_GST_MAP_REQUEST:
    case DELETE_COA_NON_TAX_GST_MAP_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case COA_NON_TAX_GST_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        coaNonTaxGstMaps: action.payload,
        message: null,
        status: null,
      };

    case CREATE_COA_NON_TAX_GST_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        coaNonTaxGstMaps: [...state.coaNonTaxGstMaps, action.payload],
        message: action.message,
        status: action.status,
      };

    case UPDATE_COA_NON_TAX_GST_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        coaNonTaxGstMaps: state.coaNonTaxGstMaps.map((item) =>
          (item.nonTaxGstId === action.payload.nonTaxGstId) ? action.payload : item
        ),
        message: action.message,
        status: action.status,
      };

    case DELETE_COA_NON_TAX_GST_MAP_SUCCESS:
      return {
        ...state,
        loading: false,
        coaNonTaxGstMaps: action?.payload?.isDelete ?
          state.coaNonTaxGstMaps.filter((item) =>
            item.nonTaxGstId !== action.payload.nonTaxGstId
          )
          :
          state.coaNonTaxGstMaps.map((item) =>
            (item.nonTaxGstId === action.payload.nonTaxGstId) ? action.payload : item
          ),
        message: action.message,
        status: action.status,
      };

    case COA_NON_TAX_GST_MAP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_COA_NON_TAX_GST_MAP_FAIL:
    case UPDATE_COA_NON_TAX_GST_MAP_FAIL:
    case DELETE_COA_NON_TAX_GST_MAP_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};